import * as React from "react";
import QueryHelper from "components/common/QueryHelper";
const queryExample = /* @__PURE__ */ React.createElement("p", null, "Find users with a email containing example.com:", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, "email:example.com"), /* @__PURE__ */ React.createElement("br", null));
const fieldMap = {
  full_name: "The full name of a user",
  username: "The users login username.",
  email: "The users email."
};
const UserQueryHelper = () => /* @__PURE__ */ React.createElement(QueryHelper, { example: queryExample, commonFields: [], fieldMap, entityName: "user" });
export default UserQueryHelper;
